require('./src/global-style.css');

exports.onInitialClientRender = () => {
    window.scrollTo(0, 0);
};
exports.shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition,
}) => {
    window.scrollTo(0, 0);

    return false;
}

exports.onRouteUpdate = ({ location, prevLocation }) => {

    if (typeof window !== "undefined") {
        const url = new URL(window.location.href);
        const paramsToRemove = ["_gl", "_gcl_au"];

        let changed = false;
        paramsToRemove.forEach(param => {
            if (url.searchParams.has(param)) {
                url.searchParams.delete(param);
                changed = true;
            }
        });

        if (changed) {
            const cleanUrl = url.origin + url.pathname + url.search + url.hash;
            window.history.replaceState({}, document.title, cleanUrl);
        }
    }

}